<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <!-- <div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div> -->
      <div class="big_tit">
        {{ $t('sky.ying') }}
      </div>
      <div class="top_right" />
    </div>
		
    <div
      ref="videoScroll"
      class="tab-content"
      @scroll.passive="handleScroll"
    >
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      >
        <div class="video-gallery-heading">
          <span>
            <van-icon name="play-circle-o" />
            {{ $t('sky.ying') }}
          </span>
        </div>
        <div class="hot-recommend-div">
          <div
            v-if="list.length"
            class="list-item"
          >
            <div
              v-for="(item, index) in list"
              :key="item.id || index"
              class="movie-list-item"
            >
              <div
                class="cover_img van-image van-image--round"
                style="width: 100%; height: 170px;"
                @click="$router.push('/vplay/'+item.id)"
              >
                <img
                  :src="item.pic"
                  class="van-image__img"
                >
                <span class="video-play-badge">
                  <van-icon name="play-circle-o" />
                </span>
              </div>
              <div
                class="movie-list-item-bottom"
                style="bottom: 33px;"
                @click="$router.push('/vplay/'+item.id)"
              >
                <div class="movie-time-div">
                  <!-- <span>{{item.title}}</span> -->
                  <span style="font-size: 12px;">
                    {{ $t('sky.play') }}:{{ item.pnum }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="loading"
            class="list-loading"
          >
            {{ $t('pro2.loading') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,
		Icon
	} from "vant";
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(Icon);
	export default {
		name: "Vindex",
		data() {
			return {
				lang: this.$i18n.locale || "en_us",
				data: null,
				loading: false,
				page: 1,
				limit: 12,
				list: [],
				cur:0,
				type:0,
				islogin: false,
				finished: false,
				empty: false,
				requestLock: false,
			};
		},
		created() {
			this.$parent.footer("video",true);
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
				return;
			}
			this.loadVideos();
		},
		methods: {
			handleScroll(event) {
				var container = event.target;
				var distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
				if (distanceToBottom <= 100) {
					this.loadVideos();
				}
			},
			loadVideos() {
				if (this.requestLock || this.finished) {
					return;
				}
				this.requestLock = true;
				this.loading = true;
				Fetch("/index/videos",{
					type:this.cur,
                    page:this.page
                }).then((r) => {
					this.data = r.data;
					var rows = r.data && r.data.list ? r.data.list : [];
					if (rows.length > 0) {
						this.list = this.list.concat(rows);
						this.page++;
					}
					this.empty = this.list.length === 0;
					this.finished = !(r.data && r.data.has_more);
					this.loading = false;
					this.requestLock = false;
				}).catch(() => {
					this.loading = false;
					this.requestLock = false;
					this.finished = true;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}
.dlg-orderlist{
	width: 100%;
	height: 100%;
	background: #f5f5f5;

.main {
	overflow: hidden
}

.vux-x-icon {
fill: #fff
}

.ctn {
position: relative;
height: 100%
}

.weui-cells {
margin-top: 0
}

.vux-button-group {
padding: 10px
}

.vux-button-group>a {
height: 36px;
line-height: 36px
}

.vux-button-group>a.vux-button-group-current {
color: #fff
}

.tab-content {
position: relative;
overflow-y: auto;
// top: 50px;
// bottom: 0;
// left: 0;
// right: 0;
padding-bottom: 84px;
-webkit-overflow-scrolling: touch
}

.tab-content .weui-cell {
padding: 10px
}

.tab-content .vux-divider {
color: #999;
font-size: 14px;
padding: 10px
}

.tab-content .weui-form-preview__bd {
font-size: 14px
}

.weui-cell_access .weui-cell__ft {
width: 100%
}

.btTime {
text-align: left
}

.btTime .s_1 {
display: inline-block;
color: #999;
font-size: 13px;
margin-right: 1rem
}

.btTime .s_2 {
font-size: 16px;
color: #333
}

.btDate,.btTime .s_6 {
font-size: 12px;
color: #999
}

.btDate {
text-align: left
}

.btDate .s_3 {
display: inline-block;
margin-right: 1rem
}

.btDate .s_4 {
display: inline-block;
font-size: 13px;
color: #666;
padding-right: 5%;
max-width: 49%
}

.btDate .s_5 {
font-size: 12px
}

.isWin {
font-size: 14px;
color: #333
}

.lose {
color: green!important
}

.winFlag {
color: #ca2316!important
}

.vux-1px-r {
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis
}

@media screen and (max-device-width: 374px) {
	.btTime .s_2 {
		font-size:14px
	}

	.btDate .s_4,.btDate .s_5 {
		font-size: 12px
	}

	.isWin {
		font-size: 14px;
		margin-top: -10px
	}
}

	.h-ctb .ctb-bd dl, .h-ctb .ctb-hd {
		height: auto;
		padding: 10px 0;
		line-height: 18px;
		word-break: break-all
	}

	.h-ctb .ctb-hd dt {
		line-height: 18px
	}

	.h-ctb .ctb-bd {
		position: absolute;
		top: 40px;
		left: 0;
		right: 0;
		bottom: 30px;
		overflow-y: auto
	}
}
/deep/ .van-card__thumb{
	width: 68px;
	height: 68px;
}
/deep/ .van-card__content{
	min-height: 68px;
}
.basic_wrap {
	height: 100vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.tab-content {
	flex: 1;
	overflow-y: auto;
	padding-bottom: 84px;
	box-sizing: border-box;
	-webkit-overflow-scrolling: touch;
}
	.box{
		padding-bottom: 10vh;
	}
	
.hot-recommend-div {
	height: 100%;
	margin: 0px auto;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-wrap: wrap;
	width: 100%;
	.list-item {
	display: flex;
	width: calc(100% - 7px);
	margin: 10px auto;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap
	}
	
	.list-item .movie-list-item {
		width: calc(50% - 8px)
	}
	
	.movie-list-item .cover_img {
	border-radius: 10px;
	width: 45vw
	}
	
	.movie-list-item {
	margin-bottom: -15px
	}
	
	.list-item .movie-list-item-bottom {
	position: relative;
	width: 100%;
	bottom: 6vw
	}
	
	.list-item .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0,0,0,.4);
		height: 30px
	}
	
	.list-item .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between
	}
	
	.list-item .movie-list-item-bottom .movie-time-div .van-count-down {
	color: #fff
	}
	
	.list-item .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 60%;
		padding-left: 8px;
		font-size: 12px
	}
	
	.list-item .movie-time-div {
		color: #fff;
		border-radius: 0 0 20px 20px;
		height: 5vw
	}
}
.list-loading {
	padding: 12px 0;
	color: #969799;
	font-size: 14px;
	text-align: center;
}

/* Video gallery follows the product catalog's light teal surface and cards. */
.basic_wrap { background: linear-gradient(180deg, #f8fcfb 0%, #edf7f5 100%); color: #23494e; }
.red_top_bg { min-height: 50px; background: rgba(255, 255, 255, .97); border-bottom: 1px solid #b9dcd8; box-shadow: 0 4px 14px rgba(7, 72, 78, .06); }
.red_top_bg .big_tit { display: flex;top: 0; height: 50px; align-items: center; justify-content: center; color: #073f47; font-size: 16px; font-weight: 600; }
.tab-content { padding: 14px 14px calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(180deg, #f8fcfb 0%, #edf7f5 100%); }
.hot-recommend-div .list-item { width: 100%; gap: 12px; margin: 0 auto; }
.hot-recommend-div .list-item .movie-list-item { width: calc(50% - 6px); margin-bottom: 0; overflow: hidden; border: 1px solid #b9dcd8; border-radius: 13px; background: rgba(255, 255, 255, .97); box-shadow: 0 10px 20px rgba(7, 72, 78, .08); }
.hot-recommend-div .movie-list-item .cover_img { height: 176px !important; border-radius: 0; background: #eaf6f4; }
.hot-recommend-div .movie-list-item .cover_img img { filter: none; }
.hot-recommend-div .list-item .movie-list-item-bottom { position: static; width: auto; bottom: auto !important; }
.hot-recommend-div .list-item .movie-list-item-bottom .movie-time-div { height: 36px; background: linear-gradient(105deg, #073f47, #0b8b92); color: #f2fffe; }
.hot-recommend-div .list-item .movie-list-item .movie-time-div span:first-child { width: auto; padding-left: 11px; font-size: 12px !important; font-weight: 600; line-height: 36px; }
.list-loading { color: #658286; }
/deep/ .van-empty { margin-top: 26px; border: 1px solid #b9dcd8; border-radius: 13px; background: rgba(255, 255, 255, .97); box-shadow: 0 10px 20px rgba(7, 72, 78, .08); }
/deep/ .van-empty__description { color: #658286; }

/* Make the video list read as a focused, image-led gallery. */
.tab-content { padding-top: 12px; }
.video-gallery-heading { display: flex; align-items: center; justify-content: space-between; margin: 0 2px 10px; color: #073f47; font-size: 16px; font-weight: 700; line-height: 24px; }
.video-gallery-heading > span { display: inline-flex; align-items: center; gap: 6px; }
.video-gallery-heading .van-icon { color: #0d8d94; font-size: 19px; }
.video-gallery-heading::after { height: 1px; flex: 1; margin-left: 10px; background: #c7e0dd; content: ''; }
.hot-recommend-div .list-item { gap: 16px 12px; }
.hot-recommend-div .list-item .movie-list-item { position: relative; overflow: hidden; border: 0; border-radius: 17px; background: #e8f5f3; box-shadow: 0 11px 24px rgba(12, 75, 79, .12); }
.hot-recommend-div .movie-list-item .cover_img { height: auto !important; aspect-ratio: 4 / 5; border-radius: 0; background: #e8f5f3; }
.hot-recommend-div .movie-list-item .cover_img::after { position: absolute; inset: 0; background: linear-gradient(180deg, transparent 42%, rgba(3, 57, 66, .68)); content: ''; pointer-events: none; }
.hot-recommend-div .movie-list-item .cover_img img { transition: transform .2s ease; }
.hot-recommend-div .movie-list-item:active .cover_img img { transform: scale(1.03); }
.video-play-badge { position: absolute; top: 50%; left: 50%; z-index: 1; width: 42px; height: 42px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(255, 255, 255, .74); border-radius: 50%; background: rgba(3, 57, 66, .52); color: #fff; font-size: 25px; transform: translate(-50%, -50%); box-shadow: 0 5px 12px rgba(3, 57, 66, .2); }
.hot-recommend-div .list-item .movie-list-item-bottom { position: absolute; right: 0; bottom: 0 !important; left: 0; z-index: 2; width: auto; }
.hot-recommend-div .list-item .movie-list-item-bottom .movie-time-div { height: 40px; padding: 0 11px; background: transparent; }
.hot-recommend-div .list-item .movie-list-item .movie-time-div span:first-child { padding-left: 0; color: #f4fffe; font-size: 12px !important; font-weight: 600; line-height: 40px; }

@media (max-width: 360px) {
  .tab-content { padding-right: 12px; padding-left: 12px; }
  .hot-recommend-div .list-item { gap: 12px 10px; }
  .video-gallery-heading { margin-right: 2px; margin-left: 2px; }
}
</style>
